import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  container: {
    padding: "16px",
    maxWidth: "800px",
    margin: "0 auto",
    backgroundColor: theme.colors.white,
    borderRadius: theme.radius.md,
    boxShadow: theme.shadows.sm,
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  label: {
    fontSize: theme.fontSizes.md,
    fontWeight: 500,
    color: theme.colors.gray[7],
  },
  input: {
    padding: "8px",
    fontSize: theme.fontSizes.md,
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colors.gray[0],
    "&:focus": {
      outline: `2px solid ${theme.colors.blue[5]}`,
      borderColor: theme.colors.blue[5],
    },
  },
  textarea: {
    padding: "8px",
    fontSize: theme.fontSizes.md,
    border: `1px solid ${theme.colors.gray[3]}`,
    borderRadius: theme.radius.sm,
    minHeight: "100px",
    resize: "vertical",
    "&:focus": {
      outline: `2px solid ${theme.colors.blue[5]}`,
      borderColor: theme.colors.blue[5],
    },
  },
  buttonContainer: {
    marginTop: "16px",
    display: "flex",
    justifyContent: "flex-end",
  },
  popupOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
    
  },
  popupContainer: {
    background:  "rgb(255, 255, 255)",
    padding: "16px",
    borderRadius: theme.radius.md,
    width: "450px",
    maxWidth: "90%",
    boxShadow: theme.shadows.md,
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  popupTitle: {
    fontSize: theme.fontSizes.lg,
    fontWeight: 600,
    color: theme.colors.gray[9],
    marginBottom: "8px",
  },
  popupDescription: {
    fontSize: theme.fontSizes.md,
    color: theme.colors.gray[7],
    lineHeight: 1.5,
    margin: 0,
    marginBottom: "12px",
  },
  popupText: {
    fontSize: theme.fontSizes.md,
    color: theme.colors.gray[7],
    lineHeight: 1.5,
    margin: 0,
    "& strong": {
      color: theme.colors.gray[9],
      fontWeight: 500,
    },
  },
  popupButtonContainer: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "8px",
    marginTop: "16px",
  },
  confirmButton: {
    padding: "8px 16px",
    fontSize: theme.fontSizes.md,
    backgroundColor: theme.colors.green[6],
    color: theme.colors.white,
    border: "none",
    borderRadius: theme.radius.sm,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.colors.green[7],
    },
  },
  cancelButton: {
    padding: "8px 16px",
    fontSize: theme.fontSizes.md,
    backgroundColor: theme.colors.red[6],
    color: theme.colors.white,
    border: "none",
    borderRadius: theme.radius.sm,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.colors.red[7],
    },
  },
}));